import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getInvoicesURL } from '../utils/urls';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StoredPMOFTag({
  bankOrIssuer,
  last4
}) {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    wrap: "wrap",
    gap: 8,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWithCard",
      options: {
        bankOrIssuer,
        last4
      }
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "cardPaymentHighlight.paymentHighlight.storedPaymentMethodTooltip_jsx",
        options: {
          href: getInvoicesURL()
        },
        elements: {
          UILink: Link
        }
      }),
      placement: "bottom left",
      children: /*#__PURE__*/_jsx(Badge, {
        use: "pantera",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.stored"
        })
      })
    })]
  });
}